export enum ApplicationDomain {
  Loans = 'Loans',
  Retainers = 'Retainers',
  Admin = 'Admin',
  Profile = 'Profile',
  Trading = 'Trading',
  DEX = 'Dex',
}
